import { render } from "./DayProjectAssignments.vue?vue&type=template&id=5158846a&scoped=true"
import script from "./DayProjectAssignments.vue?vue&type=script&lang=js"
export * from "./DayProjectAssignments.vue?vue&type=script&lang=js"

import "./DayProjectAssignments.vue?vue&type=style&index=0&id=5158846a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5158846a"]])

export default __exports__